import {Icons} from 'appearance'

export const menuItems = [
    'home',
    'clients',
    // 'statistics',
    'settings',
]

export const menuIcons = {
    home: <Icons.Home />,
    clients: <Icons.Clients />,
    statistics: <Icons.Statistics />,
    settings: <Icons.Settings />,
}

export const routes = {
    home: '/',
    clients: '/clients',
    statistics: '/statistics',
    settings: '/settings',
}
